<ng-container *ngIf="encumbrances?.length > 0">
	<div
		class="flex flex-col encumbrances w-full"
		[ngClass]="{ 'encumbrances--empty': encumbrances?.length === 0 }"
	>
		<div class="flex flex-row justify-between align-baseline items-start">
			<ui-content-header
				*ngIf="encumbrances?.length > 0"
				title="Encumbrances"
				type="page"
				class="w-fit"
			>
				<ui-button
					*ngIf="canAdd"
					title-action
					(click)="addNew()"
					label="Add"
					icon="plus"
				/>
			</ui-content-header>
			<ul class="flex w-full justify-end">
				<li *ngFor="let tab of tabs; trackBy: trackById" class="flex -ml-6">
					<app-anchor
						[tooltip]="tab.name"
						type="tab"
						[url]="tab.url"
						[cssClasses]="['pr-10']"
					>
						{{ tab.name }}
					</app-anchor>
					<app-button
						[holdable]="true"
						iconClasses="text-green"
						size="small"
						btn="tertiary"
						[icon]="ICON.REMOVE"
						class="-left-6"
						(onClick)="deleteEncumbrance(tab?.encumbranceId)"
					></app-button>
				</li>
			</ul>
		</div>
		<router-outlet class="hidden-router"></router-outlet>
	</div>
</ng-container>

<ng-container *ngIf="encumbrances?.length === 0">
	<div
		class="flex flex-col encumbrances w-full"
		[ngClass]="{ 'encumbrances--empty': encumbrances?.length === 0 }"
	>
		<div class="encumbrances__wrapper h-full">
			<div class="flex flex-col flex-1 justify-center items-center">
				<div class="empty-state-image">
					<img
						src="assets/images/empty-states/mortgages.svg"
						alt=""
						class="max-w-500"
					/>
				</div>
				<h3 class="mt-10">Add new encumbrance</h3>
				<p class="mt-3">Add a new encumbrance to your matter</p>
				<div class="mt-5">
					<app-button [icon]="ICON.ADD" size="small" (click)="addNew()"
						>Add Encumbrance</app-button
					>
				</div>
			</div>
		</div>
	</div>
</ng-container>
